import type { ShipperGroup } from './types';

// Flatten group membership into super-props shared by OpenPanel + Faro.
export function toGroupSuperProperties(groups: ShipperGroup[]): Record<string, string> {
  const byType = groups.reduce<Record<string, ShipperGroup[]>>((acc, group) => {
    (acc[group.type] ??= []).push(group);
    return acc;
  }, {});
  return Object.entries(byType).reduce<Record<string, string>>((acc, [type, typeGroups]) => {
    acc[`group_${type}`] = typeGroups.map((group) => group.name ?? group.id).join(',');
    acc[`group_${type}_id`] = typeGroups.map((group) => group.id).join(',');
    return acc;
  }, {});
}

// Empty-string clears for OpenPanel (setGlobalProperties cannot delete keys).
export function clearedGroupSuperProperties(types: Iterable<string>): Record<string, string> {
  const props: Record<string, string> = {};
  for (const type of types) {
    props[`group_${type}`] = '';
    props[`group_${type}_id`] = '';
  }
  return props;
}
